function initMap(el, options = {}) {

    const lat = el.dataset.lat;
    const long = el.dataset.long;

    let passedLongLat = [];

    if (lat !== undefined && long !== undefined) {
        passedLongLat = {
            lat: parseFloat(lat),
            lng: parseFloat(long)
        }
    }

    const defaultLatLong = {
        lat: 53.090707,
        lng: -2.4144347
    }


    const finalLatLong = {...defaultLatLong, ...passedLongLat}

    const defaultOptions = {
        zoom: 12,
        locations: [finalLatLong]
    }

    const finalOptions = {...defaultOptions, ...options};

    let markers = [];

    let map = new google.maps.Map(el, {
        zoom: finalOptions.zoom,
        center: finalOptions.locations[0]
    });

    finalOptions.locations.forEach(location => {
        markers.push(new google.maps.Marker({
                position: {lat: location.lat, lng: location.lng},
                map: map,
                width: 70,
                height: 70,
                title: "map-pin"
            })
        );
    });

}

function initMaps() {

    document.querySelectorAll("main [data-map]").forEach(el => {
        initMap(el);
    });

}
